/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import DefaultTabsBorderedBottom from './DefaultTabsBorderedBottom';

class UsuariosContent extends Component {
  render() {
    return (
      <div className="dashboard container">
        <DefaultTabsBorderedBottom
          {...this.props}
        />
      </div>
    );
  }
}

export default UsuariosContent;
